export default "__VITE_ASSET__Cejbi7gs__"